import React from 'react';
import { Disclosure as HLDisclosure } from '@headlessui/react';
import DisclosureButton from './DisclosureButton';
import DisclosurePanel from './DisclosurePanel';
import { DisclosureContext } from './useDisclosureContext';
import tw from 'twin.macro';

interface Props {
  children?: React.ReactNode;
  large?: boolean;
  fill?: boolean;
  disabled?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}

interface DisclosureContentProps {
  children: React.ReactNode;
  fill: boolean;
  large: boolean;
  disabled: boolean;
  open: boolean;
}

function DisclosureContent({
  children,
  fill,
  large,
  disabled,
  open,
}: DisclosureContentProps) {
  return (
    <div css={[tw`relative text-left`, !fill && tw`inline-block`]}>
      <DisclosureContext.Provider
        value={{
          fill,
          large,
          open: disabled ? false : open,
        }}
      >
        {children}
      </DisclosureContext.Provider>
    </div>
  );
}

export default function Disclosure(props: Props) {
  const {
    fill = false,
    children,
    large = false,
    disabled = false,
    defaultOpen = false,
    onOpenChange,
  } = props;

  const previousOpenRef = React.useRef(defaultOpen);

  return (
    <HLDisclosure defaultOpen={defaultOpen} as="div">
      {({ open }) => {
        if (open !== previousOpenRef.current) {
          previousOpenRef.current = open;
          onOpenChange?.(open);
        }

        return (
          <DisclosureContent
            fill={fill}
            large={large}
            disabled={disabled}
            open={open}
          >
            {children}
          </DisclosureContent>
        );
      }}
    </HLDisclosure>
  );
}

Disclosure.Button = DisclosureButton;
Disclosure.Panel = DisclosurePanel;
